// src/components/ui/EnhancedCodeBlock.tsx
import { Check, Copy, Terminal } from 'lucide-react';
import { useState } from 'react';

interface Props {
  lang: string;
  text: string;
  onCopy?: () => void;
}

export function EnhancedCodeBlock({ lang, text, onCopy }: Props) {
  const [copied, setCopied] = useState(false);
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      onCopy?.();
    } catch (err) {
      console.warn('Copy failed:', err);
    }
  };
  
  return (
    <div className="relative group/code rounded-xl border border-white/10 bg-black/30 overflow-hidden my-3">
      {lang && (
        <div className="flex items-center justify-between px-4 py-1.5 bg-white/5 border-b border-white/5">
          <span className="text-[10px] font-bold uppercase tracking-widest text-white/35 flex items-center gap-1.5">
            <Terminal size={10} />
            {lang}
          </span>
        </div>
      )}
      
      <button
        onClick={handleCopy}
        className="absolute top-1.5 right-2 opacity-0 group-hover/code:opacity-100 transition-all p-1 rounded-md hover:bg-white/10 z-10"
        title="复制代码"
      >
        {copied ? (
          <Check size={12} className="text-green-400" />
        ) : (
          <Copy size={12} className="text-white/40" />
        )}
      </button>
      
      <pre className="!bg-transparent !m-0 !p-4 overflow-x-auto text-xs leading-relaxed">
        <code>{text}</code>
      </pre>
    </div>
  );
}
